<template>
  <el-container class="manage-container">
    <el-header>
      <el-row class="logo"></el-row>
      <ul class="admins">
        <li class="ca ca-screen" style="display: none;">
          <router-link to="/screen/" target="_blank">大屏</router-link>
        </li>
        <li class="ca ca-group">{{ admin.groupTitle }}</li>
        <li class="ca ca-flag" v-if="admin.pid">{{ admin.point.title }}</li>
        <li class="ca ca-user">{{ admin.realname }}</li>
        <li @click="passwordDialogVisible = true" class="ca ca-password">设置密码</li>
        <li class="ca ca-sign-out" @click="logout">退出登录</li>
      </ul>
    </el-header>
    <el-container>
      <el-aside width="200px">
        <el-menu :default-active="defaultActive" router unique-opened background-color="#ff5f9a" text-color="#ffffff"
          active-text-color="#fff0f5">
          <template v-for="row in menus">
            <el-menu-item :key="row.mid" v-if="row.child == null" :title="row.name"
              :index="'/manage' + (row.controlle ? '/' + row.controlle : '') + (row.method ? '/' + row.method : '')">
              <template slot="title">
                <i :class="'ca ' + row.icon"></i>
                <span slot="title">{{ row.name }}</span>
              </template>
            </el-menu-item>
            <el-submenu v-else :index="'/manage/' + row.controlle">
              <template slot="title">
                <i :class="'ca ' + row.icon"></i>
                <span slot="title">{{ row.name }}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item v-for="child in row.child" :key="child.mid"
                  :index="'/manage/' + child.controlle + '/' + child.method"><i class="el-icon-arrow-right"></i>{{
                    child.name }}
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </template>
        </el-menu>
      </el-aside>
      <router-view></router-view>
    </el-container>

    <el-dialog title="修改密码" :visible.sync="passwordDialogVisible" :destroy-on-close="true" width="500px">
      <el-form v-model="detail" label-position="right" label-width="120px" label-suffix="：">
        <el-form-item label="旧密码">
          <el-input type="password" v-model="detail.oldpassword"></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input type="password" v-model="detail.password" placeholder="8-30位，含数字/字母/特殊字符至少 2 种"></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input type="password" v-model="detail.checkpassword"></el-input>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button @click="passwordDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveAdmin">确 定</el-button>
      </template>
    </el-dialog>
  </el-container>
</template>

<script>
import {
  httpRequest,
  passwordValid,
  aesEncrypt,
  getCookie
} from '@/utils/app';
import Cookie from 'js-cookie';
import watermark from 'watermark-package';
import {
  timeTodate
} from '@/utils/filter';

export default {
  data () {
    return {
      passwordDialogVisible: false,
      menus: [],
      defaultActive: '',
      detail: {
        oldpassword: '',
        password: '',
        checkpassword: ''
      }
    }
  },
  created () {
    this.admin = getCookie('admin')
    // 用户权限
    httpRequest({
      action: 'adminGroup_rights',
      gid: this.admin.gid
    }).then(response => {
      if (response.error) {

      } else {
        this.menus = response.data
      }
    })
  },
  mounted () {
    // 默认菜单
    this.defaultActive = this.$route.path === '/manage/' ? '/manage/' : this.$route.path

    // 页面水印
    watermark.setWaterMark({
      w_texts: [this.admin.realname, timeTodate(this.admin.lasttime, 'Y-m-d-H-i-s')],
      w_options: {
        w_width: 320,
        w_height: 140,
        w_top: '0px',
        w_left: '0px',
        w_rotateDeg: 30,
        w_font: '14px Tahoma',
        w_color: '#bdbdbd',
        w_opacity: 0.3,
        w_zIndex: 3000,
      }
    })
  },
  methods: {
    logout () {

      Cookie.set('admin', aesEncrypt(JSON.stringify({})))

      // 登录页已从首页 (/) 独立到 /login，退出后回到登录页而非官网首页
      this.$router.push('/login')
    },
    saveAdmin () {
      // 旧密码不做前端本地比对（登录接口也只回传业务数据，不下发密码哈希），统一交后端校验
      if (this.detail.oldpassword.trim() === '') {
        this.$message({
          type: 'error',
          message: '请输入当前帐号的登录密码'
        })
        return
      }

      if (this.detail.password != this.detail.checkpassword) {
        this.$message({
          type: 'error',
          message: '新密码与确认密码不一致'
        })
        return
      }

      // 强度口径与「人员列表-登录密码」完全一致，避免两处规则漂移
      if (!passwordValid(this.detail.password)) {
        this.$message({
          type: 'error',
          message: '密码需 8-30 位，且包含数字/字母/特殊字符中至少 2 种'
        })
        return
      }

      let that = this
      // 与登录接口同口径：密码用 aesEncrypt 加密后传输，后端 desEncrypt 还原再取 MD5
      httpRequest({
        action: 'admin_password',
        aid: this.admin.aid,
        password: aesEncrypt(this.detail.password),
        oldpassword: aesEncrypt(this.detail.oldpassword)
      }, 'POST')
        .then(response => {
          if (response.error) {
            this.$message({
              type: 'error',
              message: response.msg
            })
          } else {
            this.passwordDialogVisible = false
            this.$message({
              type: 'success',
              message: response.msg,
              onClose: function () {
                that.logout()
              }
            })
          }
        })
    }
  },
  watch: {
    // 关闭弹窗时清空已输入的密码，不残留于内存
    passwordDialogVisible: function (val) {
      if (!val) {
        this.detail = {
          oldpassword: '',
          password: '',
          checkpassword: ''
        }
      }
    },
    $route: function (e) {
      let paths = e.path.split('/')
      if (paths.length > 4) {
        paths.pop()
      }

      this.defaultActive = paths.join('/')
    }
  }
}
</script>